var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLsk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0D4EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01505 14.0389C8.00717 14.0468 7.99142 14.0546 7.98355 14.0625H7.11055C7.0948 14.0625 7.08692 14.0546 7.07905 14.0468L4.50561 11.1398C4.50186 11.1325 4.49991 11.1245 4.49991 11.1164C4.49991 11.1083 4.50186 11.1003 4.50561 11.0931L7.71074 5.56087C7.72649 5.53781 7.7653 5.53781 7.78105 5.56087L8.67767 7.11225C8.68555 7.12013 8.68555 7.13587 8.67767 7.15162L6.5098 10.8894C6.50192 10.9046 6.5098 10.9204 6.51767 10.9361L7.81199 12.3936C7.82064 12.4019 7.83163 12.4074 7.84349 12.4093H9.3718C9.41117 12.4093 9.42636 12.4487 9.40274 12.4718L8.01505 14.0389ZM8.96567 3.39863C8.98199 3.36713 9.0208 3.36713 9.02867 3.39863L13.4966 11.0767C13.5045 11.0931 13.4966 11.1088 13.4887 11.124L10.9159 14.031C10.9072 14.0393 10.8962 14.0448 10.8844 14.0468H8.79467C8.7553 14.0468 8.74011 14.0074 8.76374 13.9843L10.1593 12.4014L11.4694 10.9282C11.4851 10.9125 11.4851 10.8967 11.4772 10.8816L8.99717 6.60319L8.06174 4.98881C8.05386 4.9815 8.05386 4.96575 8.06174 4.94944L8.96567 3.39863Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLsk);
export default __webpack_public_path__ + "static/media/lsk.ddbff4c47b96855c09e8fb68aad4dc15.svg";
export { ForwardRef as ReactComponent };